import { useEffect } from 'react';

// Injects JSON-LD structured data for Google rich results
// Usage: <JsonLD data={{ '@type': 'LocalBusiness', ... }} />
export default function JsonLD({ data, id }) {
  useEffect(() => {
    const scriptId = `json-ld-${id || data['@type'] || 'schema'}`;
    
    // Remove existing script with same ID to avoid duplicates
    const existing = document.getElementById(scriptId);
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.type  = 'application/ld+json';
    script.id    = scriptId;
    script.text  = JSON.stringify(data, null, 0);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(scriptId);
      if (el) el.remove();
    };
  }, [data, id]);

  return null;
}
